"use strict";
// @ts-ignore
try {
    self['workbox:routing:7.2.0'] && _();
}
catch (e) { }
